import { site } from '../data/site'

export default function Navbar() {
  return (
    <header className="sticky top-0 z-20 backdrop-blur bg-white/80 border-b border-black/5">
      <div className="w-full px-6 sm:px-10 lg:px-16 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2.5">
          <img src="/NPDT로고.png" alt="NPDT" className="w-8 h-8" />
          <div className="leading-tight">
            <div className="font-bold text-navy">{site.name}</div>
            <div className="text-[10px] text-navy/60 tracking-wide">
              {site.fullName}
            </div>
          </div>
        </a>

        <a
          href={site.dashboardUrl}
          className="inline-flex items-center gap-1.5 rounded-full bg-brand text-white text-sm font-semibold px-4 py-2 hover:bg-brand-dark transition shadow-sm"
        >
          대시보드 <span aria-hidden>→</span>
        </a>
      </div>
    </header>
  )
}
